// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Label = require("../../common/Components/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return x.value;
}

let Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function makeOption(value) {
  let tmp;
  switch (value) {
    case "AGENTS_ONLY" :
      tmp = "Agents only";
      break;
    case "BUYERS_WELCOME" :
      tmp = "Buyers welcome";
      break;
    case "TAN_ONLY" :
      tmp = "TAN only";
      break;
  }
  return {
    value: value,
    label: tmp
  };
}

let options = [
  "TAN_ONLY",
  "AGENTS_ONLY",
  "BUYERS_WELCOME"
].map(makeOption);

function WizardShowingTypeInputField(props) {
  let onChange = props.onChange;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Showing type"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: getOptionLabel,
        getOptionValue: getOptionValue,
        isClearable: true,
        onChange: value => onChange(Stdlib_Option.map(value, param => param.value)),
        options: options,
        placeholder: "Showing type",
        value: Stdlib_Option.map(props.value, makeOption)
      })
    ]
  });
}

let make = WizardShowingTypeInputField;

exports.Option = Option;
exports.makeOption = makeOption;
exports.options = options;
exports.make = make;
/* options Not a pure module */
